import { Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { ApiPaths } from "../../../api/paths";
import DeleteIcon from "../../../components/icons/DeleteIcon";
import useMutateData from "../../../hooks/use-mutate-data";
import { StaffType } from "../../../types/staff";
import "./delete-staff.css";

interface Props {
  show: boolean;
  onHide: () => void;
  selectedItem?: StaffType;
  onSuccess?: () => void;
}

export default function DeleteStaff({
  show,
  onHide,
  selectedItem,
  onSuccess,
}: Props) {
  const { t } = useTranslation(["common", "manageStaff"]);
  const { mutate } = useMutateData(`${ApiPaths.staff}/${selectedItem?.id}`, {
    onSuccess: () => {
      toast(t("details.message.success_delete", { ns: "manageStaff" }), {
        type: "success",
      });
      onHide();
      onSuccess?.();
    },
    onError: () => {
      toast(t("error.default", { ns: "common" }), {
        type: "error",
        toastId: "staff-delete",
      });
      onHide();
    },
    method: "DELETE",
  });
  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Body className="text-center d-flex flex-column align-items-center p-3 py-5 p-md-5">
        <h2 className="primary-modal-title modal-danger-title mb-2 mb-md-4">
          {t("details.heading.delete", { ns: "manageStaff" })}
        </h2>
        <div className="cancel-policy-icon-cont delete-icon-cont rounded-circle mb-2 mb-md-4">
          <DeleteIcon />
        </div>
        <p className="mb-2 mb-md-4">
          {t("details.text.delete.message", {
            ns: "manageStaff",
          })}
          {` `}
          <span>{`"${selectedItem?.username}"`}?</span>
        </p>
        <div className="d-flex justify-content-center align-items-center">
          <button
            className="modal-primary-button modal-secondary-button me-4"
            onClick={onHide}
          >
            {t("button.back", { ns: "common" })}
          </button>
          <button className="modal-primary-button" onClick={() => mutate()}>
            {t("button.yes", { ns: "common" })}
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
}
